<template>
	<div class="container g-flex g-row-center">
		<!--   去注册   -->
		<div class="login-input-box g-flex g-col-top">
			<img src="@/assets/login/login-ad.png" class="ad" alt="">
			<div class="login-form g-m-l-70">
				<div style="font-size: 20px;font-weight: bold;margin-bottom:20px;">
					扫码登录
				</div>
				<div class="qr">
					<img :src="qr" />
				</div>
				<div style="color:#999999;font-size:14px;margin-top:10px;">
					微信扫一扫快捷登录
				</div>
				<div style="margin-top:50px;text-align: center;">
					<p class="remark-text pointer" @click="backHome">返回首页</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Cookies from 'js-cookie';
	import md5 from 'js-md5'
	import {
		login,
		userInfo,
		register,
		getLoginQr,
		checkLogin
	} from "@/api/user.js"
	import {
		resumelDetail
	} from "@/api/job.js"
	import {
		HumpObj
	} from "@/utils/common.js"
	import sendCode from "@/mixins/sendCode";
	export default {
		name: "login",
		mixins: [sendCode],
		data() {
			return {
				active: 1, //1 登录 2 注册
				tabIndex: '1', //1 密码登录 2 验证码登录
				phone: '',
				psw: '',
				textCode: '',
				throttleFlag: true ,//注册节流标志
				timer: null,
				qr: '',
				qrsence: '',
			}
		},
		mounted() {
			
			history.pushState(null, null, document.URL);
			window.addEventListener("popstate", function() {
				history.pushState(null, null, document.URL);
			});
			this.getLoginQr()

		},
		beforeDestroy() {
			clearInterval(this.timer);
			this.timer = null;
		},
		destroyed() {
			this.$store.commit('$uStore', {
				name: 'hasAlert',
				value: false
			});
		},
		methods: {
			// 返回首页
			backHome() {
				this.$router.replace({
					path: '/'
				})
			},
			
			getLoginQr() {
				getLoginQr().then(res => {
					console.log(res)
					this.qr = res.image
					this.qrsence = res.key
					// this.timer = setInterval(() => {
					// 	setTimeout(this.checkLogin, 0);
					// }, 1000);
					this.checkLogin()
				})
			},
			checkLogin() {
				checkLogin({
					scene:this.qrsence
				}).then(res=>{
					if(res.code==0){
						this.timer=setTimeout(()=>{
							this.checkLogin()
						},2000)
					}else{
						if(res.code==200){
							this.$store.commit('$uStore', {
								name: 'isLogin',
								value: true
							})
							this.$store.commit('$uStore', {
								name: 'accessToken',
								value: res.data.access_token
							})
							localStorage.setItem('accessToken', res.data.access_token);
							this.$store.commit('$uStore', {
								name: 'refreshToken',
								value: res.data.access_token
							})
							this.$store.commit('$uStore', {
								name: 'userInfo',
								value:  res.data
							})
							this.getMyResume();
							this.getUserInfo();
							this.$router.replace({
								name: 'home'
							})
						}
						
					}
				})
			},
			
			getUserInfo() {
				userInfo({}).then(res => {
					let storeUserInfo = this.$store.state.userInfo;
					Object.assign(res, storeUserInfo);
					this.$store.commit('$uStore', {
						name: 'userInfo',
						value: res
					});
				})
			},
			getMyResume() {
				resumelDetail({}).then(res => {
					this.$store.commit('$uStore', {
						name: 'userInfo.resumeId',
						value: res.id
					})
				})
			},
			// 登录
			doLogin() {
				// 账号密码登陆
				if (this.tabIndex === '1') {
					if (!this.phone) {
						return this.$message.error('请输入账号！')
					}
					if (!this.psw) {
						return this.$message.error('请输入密码！')
					}
					if (this.psw.length < 6) {
						return this.$message.error('密码长度不小于6位字符！')
					}
					let obj = {
						tenantId: '000000',
						mobile: this.phone,
						password: md5(this.psw),
						grant_type: 'password'
					}
					login(obj).then(res => {
						//Cookies.set('token',res.access_token)
						//Cookies.set('refresh_token',res.refresh_token)
						//Cookies.set('login_info',JSON.stringify(res))
						this.$store.commit('$uStore', {
							name: 'isLogin',
							value: true
						})
						this.$store.commit('$uStore', {
							name: 'accessToken',
							value: res.access_token
						})
						localStorage.setItem('accessToken', res.access_token);
						this.$store.commit('$uStore', {
							name: 'refreshToken',
							value: res.access_token
						})
						this.$store.commit('$uStore', {
							name: 'userInfo',
							value: res
						})
						this.getMyResume();
						this.getUserInfo();
						this.$router.replace({
							name: 'home'
						})
					}).catch(e => {
						console.log("eeeee", e)
					})


				} else {
					// 验证码登录
					if (!this.phone) {
						return this.$message.error('请输入账号！')
					}
					if (!this.textCode) {
						return this.$message.error('请输入验证码！')
					}
					let obj = {
						tenantId: '000000',
						mobile: this.phone,
						grant_type: 'mobile'
					}
					login(obj, {
						headers: {
							'Captcha-Key': this.key,
							'Captcha-Code': this.textCode
						}
					}).then(res => {
						this.key = ''
						this.code = ''
						this.$store.commit('$uStore', {
							name: 'isLogin',
							value: true
						})
						this.$store.commit('$uStore', {
							name: 'accessToken',
							value: res.access_token
						})
						localStorage.setItem('accessToken', res.access_token);
						this.$store.commit('$uStore', {
							name: 'refreshToken',
							value: res.access_token
						})
						this.$store.commit('$uStore', {
							name: 'userInfo',
							value: res
						})
						this.getMyResume();
						this.getUserInfo();
						this.$router.replace({
							name: 'home'
						})
					}).catch(e => {
						console.log("eeeee", e)
					})
				}
				// todo...
			},
			// 注册事件，注册完成后切换登录
			doRegister() {
				if (!this.phone) {
					return this.$message.error('请输入账号！')
				}
				if (!this.textCode) {
					return this.$message.error('请输入验证码！')
				}
				if (!this.psw) {
					return this.$message.error('请输入密码！')
				}
				if (this.psw.length < 6) {
					return this.$message.error('密码长度不小于6位字符！')
				}
				let obj = {
					tenantId: '000000',
					mobile: this.phone,
					password: this.psw,
					code: this.textCode,
					key: this.key
				}
				if (this.throttleFlag) {
					this.throttleFlag = false;
					register(obj).then(res => {
						this.$message.success('注册成功')
						this.active = 1
						this.tabIndex = '1'
						this.key = ''
						this.code = ''
						this.sence = 'token'
						this.textCode = ''
						this.throttleFlag = true;
						this.send = false
						this.times = 60
					}).catch(e => {
						console.log("eeeee", e)
						this.throttleFlag = true;
						if (e.data.code == 444) {
							this.$confirm(e.data.msg, '提示', {
								confirmButtonText: '确定',
								type: 'warning'
							}).then(() => {
								this.active = 1
								this.tabIndex = '2'
								this.key = ''
								this.code = ''
								this.sence = 'token'
								this.textCode = ''
								this.throttleFlag = true;
								this.send = false
								this.times = 60
							}).catch(() => {

							});

						}
					})
				} else {
					setTimeout(() => {
						this.throttleFlag = true;
					}, 1000)
				}


			},
			//  跳转忘记密码
			goForgetPsw() {
				this.$router.push({
					name: 'found-psw'
				})
			},

			// 我要入驻跳转到后台管理的注册页
			tabClick(e) {
				if (e.index === '1') {
					// 跳转到后台的注册的逻辑
					window.location.href = 'https://admin.yzhkq.com/'
				}
			}
		},
	}
</script>

<style lang="scss" scoped>
	.container {
		background-image: url("../../assets/login/login-bg.png");
		background-size: 100% 100%;
		background-repeat: no-repeat;
		width: 100%;
		height: 100vh;
	}

	.input-img {
		width: 20px;
		height: 20px;
		margin-right: 10px;
	}

	.login-input-box {
		background: #fff;
		border-radius: 10px;
		padding: 30px;
	}

	.ad {
		width: 350px;
		height: 540px;
	}

	.login-form {
		text-align: center;
		width: 390px;
	}
	.login-form img{
		width: 100%;
	}
	.qr {
		min-height: 340px;
		padding: 0 25px;
		text-align: center;
	}
	
	.qr img {
		width: 100%;
		height:auto;
	}
	::v-deep .el-tabs__nav-wrap::after {
		background: none;
	}

	::v-deep .el-tabs__active-bar {
		width: 80px !important;
		left: 12%;
	}

	::v-deep .el-tabs__item.is-active {
		color: #000 !important;
		font-weight: bold;
		font-size: 20px !important;
	}

	::v-deep .el-tabs__item {
		color: #999;
		font-size: 20px !important;
	}

	.form-width {
		width: 380px;
	}

	.input-row {
		background: #f6f6f8;
		border-radius: 5px;
		padding: 4px 20px;
	}

	::v-deep .el-input__inner {
		border: none;
		outline: none;
		background-color: #f6f6f8;
		padding: 0 7px;
	}

	::v-deep .el-tabs__item {
		font-size: 14px;
	}

	.remark {
		background: #fffaef;
		border-radius: 5px;
		padding: 8px 10px;
		color: #eea906;
	}

	.submit-btn {
		padding: 13px 0;
		font-size: 14px;
		width: 100%;
		margin: 40px 0 30px;
	}

	.text-code-btn {
		padding: 0 5px;
		margin: 0 0 0 20px;
		width: 50%;
		white-space: nowrap;
		font-size: 12px;
	}
</style>
